import { UserResponse, User } from "../types";
import axios from "axios";
import config from "../config";

class AuthService {
  async login(secret_code: string): Promise<null | User> {
    const data: UserResponse = (
      await axios.post(`${config.API}/auth/login`, { secret_code })
      ).data;
      if (!data) return null;
      if (data.status === "error" || !data.data) return null;
      localStorage.token = secret_code;
      const userData: User = data.data;
    return userData;
  }
}
const authService = new AuthService();
export default authService;
